<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">


            <el-form-item label="附件类别" prop="fileCategoryCode">
                <file-catrgory-select v-model="formData.fileCategoryCode"></file-catrgory-select>
            </el-form-item>


            <el-form-item label="上传附件" prop="file">

                <el-upload
                        drag
                        :on-change="handleFileChange"
                        :auto-upload="false"
                        :multiple="false">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
<!--                    <div class="el-upload__tip" slot="tip">建议文件不超过500kb</div>-->
                </el-upload>
            </el-form-item>







            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    import FileCatrgorySelect from "../../components/FileCategorySelect";
    export default {
        name: "RoleAdd",
        components: {FileCatrgorySelect},
        data() {
            return {
                api:{
                   add:this.$api.fileRecord.add
                },
                formErrorMsg:{
                    name: '',
                    flag: '',
                    fileCategoryCode: '',
                },
                formData: {
                    name: '',
                    fileCategoryCode: '',
                    flag: '',
                    file:''
                },
                rules: {
                    name: [
                        {required: true, message: '请输入附件名称', trigger: 'blur'},
                    ],
                    fileCategoryCode: [
                        {required: true, message: '请选择附件类别', trigger: 'blur'},
                    ],
                    file: [
                        {required: true, message: '请选择上传文件', trigger: 'blur'},
                    ]

                }
            }
        },
        methods: {
            handleFileChange(){
                this.formData.file = arguments[0].raw;
            },
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {

                        let formData = new FormData();
                        for(let key in this.formData){
                            formData.append(key,this.formData[key]);
                        }

                        let config = {
                            headers:{'Content-Type':'multipart/form-data'}
                        };


                        vm.$http.post(vm.api.add,formData,config).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(()=>{
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if(resp.data.desc){
                                    vm.$message({
                                        type:"error",
                                        message: resp.data.desc
                                    });
                                }


                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
            let vm = this;

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form {
        max-width: 500px;
    }

</style>